import React from 'react';
import { Route, Switch } from 'react-router-dom';
import MembersList from 'componentsv2/MemberList';
import LineupRequests from 'componentsv2/LineupRequests/LineupRequests';
import Event from 'modules/dashboard/pagesv2/event/index.js';
import JornadasMain from './jornadas/jornadasMain/JornadasMain';
import Jornadas from './jornadas';
import Events from 'modules/dashboard/pagesv2/events/Events';
import EmptyPage from 'components/Events/EmptyPage';
import Profile from 'components/Profile/Profile';
import ProfileEdit from 'components/Profile/ProfileEdit';
import NewEvent from 'modules/dashboard/pages/new-event';
import Transactions from './transactions';
import { paths } from 'configs/paths';

const { dashboard, event } = paths;

const Dashboard = () => {
  return (
    <Switch>
      <Route exact path={dashboard.myEvents} render={() => <EmptyPage pageTitle="Mis Eventos" />} />
      <Route
        exact
        path={dashboard.pastEvents}
        render={() => <EmptyPage pageTitle="Eventos Pasados" />}
      />
      <Route path={dashboard.newEvent} component={NewEvent} />
      <Route exact path={dashboard.editProfile} component={ProfileEdit} />
      <Route exact path={dashboard.profile} component={Profile} />
      <Route exact path={dashboard.dashboard} component={Events} />
      <Route exact path={dashboard.transactions} component={Transactions} />
      <Route exact path={event.members(':teamId', ':tournamentId')} component={MembersList} />
      <Route
        exact
        path={event.lineupRequest(':teamId', ':tournamentId')}
        component={LineupRequests}
      />
      <Route exact path={event.journeysMain(':eventId', ':groupId')} component={JornadasMain} />
      <Route
        exact
        path={event.journeys(':eventId', ':groupId', ':matchDayId', ':matchId')}
        component={Jornadas}
      />
      <Route path={dashboard.event(':eventId')} component={Event} />
      <Route
        exact
        path="/*"
        render={() => (
          <div className="py-6 px-3 mb-6 text-center">
            <h2 className="text-brandblue text2xl md:text-5xl mb06">404</h2>
            <p className="text-gray-500 text-lg">La pagina que buscas no existe.</p>
          </div>
        )}
      />
    </Switch>
  );
};

export { Dashboard };
